import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from 'moment';

import { SingleRedio, SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { CancelSubmitButton, Space, EditButton } from '../../../Res/BaseButton';
import { ContentBox } from '../../../Content/ContentBox';
import { SystemPromptInput } from '../../../Res/SystemPrompt';
import { getval2Token } from '../../../../Login/Auth';
import { api_addTeam, api_getTeamDetail, api_checkTeamName } from '../../../../../api/MyStat/apiTeam';
import { ReqTeamDetail, RespTeam } from '../../../../../item/MyStat/ItemTeam';
import { UploadPhoto } from '../UploadPhoto';
import { get_activation_string, activation_Items, ACTIVATION_ENABLE, ACTIVATION_DISABLE } from '../../../../../item/MyStat/ItemMyStatBase';
import 'rc-datepicker/lib/style.css';
import { api_getLeagueListEnable } from '../../../../../api/MyStat/apiLeague';
import { api_getParkListEnable } from '../../../../../api/MyStat/apiPark';
import { TeamHistory } from './TeamHistory';
import { uuid } from '../../../../../item/ItemTools';


export function TeamEdit({ id, setIsLoading, isEdit, isAdd = false }) {
  const [tokenId, setTokenId] = useState("")
  const [league_association_arr, set_league_association_arr] = useState([])
  const [park_home_arr, set_park_home_arr] = useState([])
  const [team_history_items, set_team_history_items] = useState([])

  const [_id, set_id] = useState("")
  const [team_id, set_team_id] = useState("")
  const [team_name, set_team_name] = useState("")
  const [team_name_eng, set_team_name_eng] = useState("")
  const [total_players, set_total_players] = useState(0)
  const [team_activation, set_team_activation] = useState(ACTIVATION_ENABLE)
  const [team_last_change, set_team_last_change] = useState("")
  const [team_note, set_team_note] = useState("")

  const [logo_team, set_logo_team] = useState("")
  const [logo_team_auth, set_logo_team_auth] = useState(0)
  const [logo_team_date, set_logo_team_date] = useState("")

  const [league_association, set_league_association] = useState("")
  const [league_name, set_league_name] = useState("")
  const [park_home, set_park_home] = useState("")
  const [park_name, set_park_name] = useState("")
  const [team_GM_name, set_team_GM_name] = useState("")
  const [team_manager_name, set_team_manager_name] = useState("")
  const [team_web, set_team_web] = useState("")

  const [isCheckRepeat, setCheckRepeat] = useState(false)
  const [isRepeat, setRepeat] = useState(false)
  const [repeatMessage, setRepeatMessage] = useState("")

  const [birthError, setBirthError] = useState(false)

  const [is_get_league_association, set_is_get_league_association] = useState(false)
  const [is_get_park_home, set_is_get_park_home] = useState(false)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("TeamEdit", id)
      console.log(obj)
      set_team_id(obj.team_id)
      setTokenId(id)
    }
    if(isAdd){
      set_team_id(uuid(32,64))
    }
  }, [id])

  useEffect(() => {
    get_league_association()
    get_park_home()
  }, [])

  useEffect(() => {
    if (!is_get_league_association || !is_get_park_home) {
      return
    }
    if (!isAdd && team_id !== undefined && team_id !== "") {
      // setIsLoading(true)
      var mReqTeamDetail = new ReqTeamDetail({
        team_id
      })
      getDetail(mReqTeamDetail)
    }
  }, [team_id, is_get_league_association, is_get_park_home])

  useEffect(()=>{
    console.log(_id)
  },[_id])

  function get_league_association() {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    api_getLeagueListEnable({
      success: (obj) => {
        var arr = []
        obj.list.forEach(item => {
          arr.push({ val: item.league_id, name: item.league_name })
        })
        console.log(arr)
        set_league_association_arr(arr)
        set_is_get_league_association(true)
        if (setIsLoading !== undefined)
          setIsLoading(false)
      },
      failure: (err) => {
        if (setIsLoading !== undefined)
          setIsLoading(false)
      }
    })
  }

  function get_park_home() {
    if (setIsLoading !== undefined)
      setIsLoading(true)
    api_getParkListEnable({
      success: (obj) => {
        var arr = []
        obj.list.forEach(item => {
          arr.push({ val: item.park_id, name: item.park_name })
        })
        console.log(arr)
        set_park_home_arr(arr)
        set_is_get_park_home(true)
        if (setIsLoading !== undefined)
          setIsLoading(false)
      },
      failure: (err) => {
        if (setIsLoading !== undefined)
          setIsLoading(false)
      }
    })
  }

  function getDetail(mReqTeamDetail) {
    console.log(mReqTeamDetail)
    setIsLoading(true)
    api_getTeamDetail({
      mReqTeamDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespTeam = new RespTeam({})
        mRespTeam.fromJson(jsonData.detail)

        set_id(mRespTeam.id)
        set_team_name(mRespTeam.team_name)
        set_team_name_eng(mRespTeam.team_name_eng)
        set_team_activation(mRespTeam.team_activation)
        set_team_last_change(moment(mRespTeam.team_last_change).format('YYYY-MM-DD'))
        set_team_note(mRespTeam.team_note)
        set_logo_team(mRespTeam.logo_team)
        set_logo_team_auth(mRespTeam.logo_team_auth)

        var logo_date = moment(mRespTeam.logo_team_date).format('YYYY-MM-DD HH:mm:ss')
        if (logo_date === "Invalid date")
          logo_date = ""
        set_logo_team_date(logo_date)

        set_league_association(mRespTeam.league_association)
        set_league_name(mRespTeam.league_name)
        set_park_home(mRespTeam.park_home)
        set_park_name(mRespTeam.park_name)
        set_team_GM_name(mRespTeam.team_GM_name)
        set_team_manager_name(mRespTeam.team_manager_name)
        set_team_web(mRespTeam.team_web)

        try {
          var team_history_items = JSON.parse(mRespTeam.team_history_items)
          team_history_items.sort(GetSortOrder("team_duration_start"));
          set_team_history_items(team_history_items)
        } catch (error) {
          console.log(error)
        }
        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function GetSortOrder(prop) {    
    return function(a, b) {    
        if (a[prop] < b[prop]) {    
            return 1;    
        } else if (a[prop] > b[prop]) {    
            return -1;    
        }    
        return 0;    
    }    
}    
    

  function checkName(val) {
    setIsLoading(true)
    var mRespTeam = new RespTeam({
      team_name: val,
    })
    console.log(mRespTeam)
    api_checkTeamName({
      mRespTeam,
      success: (jsonData) => {
        console.log(jsonData)
        setIsLoading(false)
        setCheckRepeat(true)
        if (jsonData.id === "") {
          setRepeat(false)
          setRepeatMessage("此球隊名稱無重覆")
        } else {
          setRepeat(true)
          setRepeatMessage("與球隊編號" + jsonData.id + "同名")
        }
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  function toEdit() {
    window.location.assign("/Team_Edit/" + id);
  }

  function toCancel() {
    window.history.back();
  }

  function toAdd() {
    // console.log(team_type)
    var inputError = []
    var dateError = []
    if (team_name === "") {
      inputError.push("中文名字")
    }

    team_history_items.sort(GetSortOrder("team_duration_start"));
    var item_temp = null
    team_history_items.forEach(item=>{
      console.log(item)
      if(item.team_name === ""){
        inputError.push("球隊歷史名稱 中文名稱")
      }
      if(item_temp === null){
        if(item.team_duration_start === null){
          inputError.push(item.team_name + "適用起始")
        }else{
          item_temp = item
        }
      }else{
        if(item.team_duration_start === null){
          inputError.push(item.team_name + "適用起始")
        }
        if(item.team_duration_end === null){
          inputError.push(item.team_name + "適用結束")
        }
        if (inputError.length === 0) {
          try {
            var start = moment(item.team_duration_start)
            var end  = moment(item.team_duration_end )
            var diff_days = start.diff(end, 'days')
            if(diff_days > 0){
              dateError.push("["+ item.team_name + "]適用起始 不得晚於 適用結束")
            }
            var start_tmp = moment(item_temp.team_duration_start)
            var tmp_diff_days = end.diff(start_tmp, 'days')
            console.log(end)
            console.log(start_tmp)
            console.log(tmp_diff_days)
            if(tmp_diff_days > -1){
              dateError.push("["+ item_temp.team_name + "] 適用起始 不得晚於 [" + item.team_name + "] 適用結束")
            }
            item_temp = item
          } catch (error) {
            
          }
        }
      }
    })
    console.log(inputError)

    if (inputError.length > 0) {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: inputError.join(',') + ' 為必填',
      })
      return
    }else if(dateError.length > 0){
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: dateError.join(','),
      })
      return
    }
    setIsLoading(true)
    var mRespTeam = new RespTeam({
      team_id,
      team_name,
      team_name_eng,
      team_activation,
      team_last_change,
      team_note,
      logo_team,
      logo_team_auth,
      logo_team_date,
      league_association,
      park_home,
      team_GM_name,
      team_manager_name,
      team_web
    })

    console.log(mRespTeam)
    console.log(team_history_items)
    api_addTeam({
      isAdd,
      team: mRespTeam,
      history : team_history_items,
      success: (jsonData) => {
        setIsLoading(false)
        Swal.fire({
          type: 'success',
          title: '提醒',
          text: isAdd ? '新增成功' : '修改成功',
        }).then(function () {
          toCancel()
        })
      },
      failure: (err) => {
        setIsLoading(false)
        Swal.fire({
          type: 'error',
          title: '提醒',
          text: err,
        })
      }
    })
  }

  var title = "球隊" + (isAdd ? "新增" : isEdit ? "編輯" : "檢視")
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          {isEdit ?
            <SingleInput title={"中文名稱"} val={team_name} action={set_team_name} action_blur={checkName} placeholder={""} size={4} />
            : <SingleText title={"中文名稱"} val={team_name} size={4} />
          }

          {isEdit ?
            <SingleInput title={"英文名稱"} val={team_name_eng} action={set_team_name_eng} placeholder={""} size={4} />
            : <SingleText title={"英文名稱"} val={team_name_eng} size={4} />
          }
          {isAdd ?
            <></>
            : <SingleText title={"編號"} val={_id} size={2} />
          }
          {isAdd ?
            <></>
            : <SingleText title={"球員總數"} val={total_players} size={2} />
          }
        </div>
        <div className="col-sm-12">
          {isCheckRepeat ?
            <div className="col-md-4">
              <p className={isRepeat ? "text-danger" : "text-info"}>{repeatMessage}</p>
            </div>
            : <></>}
        </div>
        
        <div className="col-sm-12">
          <div className="hr-line-dashed"></div>
        </div>

        <div className="col-sm-12">
          <div className="col-md-10 col-sm-offset-1">
            <TeamHistory title={"球隊歷史名稱管理"} teamId={team_id} items={team_history_items} action={set_team_history_items} isEdit={isEdit} />
          </div>
        </div>
        <div className="col-sm-12">
          {isEdit ?
            <SingleSelect title={"所屬聯盟"}
              val={league_association}
              attr={league_association_arr}
              action={set_league_association}
              hasBlank={true}
              size={4}
            />
            : <SingleText title={"所屬聯盟"} val={league_name} size={4} />
          }
          {isEdit ?
            <SingleSelect title={"主場"}
              val={park_home}
              attr={park_home_arr}
              action={set_park_home}
              hasBlank={true}
              size={4}
            />
            : <SingleText title={"主場"} val={park_name} size={4} />
          }
          {
            isEdit ?
              <SingleRedio title={"啟停用"}
                arr={activation_Items}
                val={team_activation ? ACTIVATION_ENABLE : ACTIVATION_DISABLE}
                action={set_team_activation}
                size={2}
              />
              :
              <SingleText title={"啟停用"}
                val={get_activation_string(team_activation)}
                size={2} />
          }
          {isAdd ?
            <></>
            : <SingleText title={"異動日期"} val={team_last_change} size={2} />
          }
        </div>
        <Space />
        <Space />
        <div className="col-sm-12">
          {isEdit ?
            <SingleInput title={"領隊名稱"} val={team_GM_name} action={set_team_GM_name} placeholder={""} size={4} />
            : <SingleText title={"領隊名稱"} val={team_GM_name} size={4} />
          }

          {isEdit ?
            <SingleInput title={"總教練名稱"} val={team_manager_name} action={set_team_manager_name} placeholder={""} size={4} />
            : <SingleText title={"總教練名稱"} val={team_manager_name} size={4} />
          }
          {isEdit ?
            <SingleInput title={"球隊網址"} val={team_web} action={set_team_web} placeholder={""} size={4} />
            : <SingleText title={"球隊網址"} val={team_web} size={4} />
          }
        </div>
        <Space />
        <Space />
        <div className="col-sm-12">
          {isEdit ?
            <SingleInput title={"註記"} val={team_note} action={set_team_note} placeholder={"內部人員註記"} size={12} />
            : <SingleText title={"註記"} val={team_note} size={12} />
          }
        </div>
        <Space />
        <Space />

        <div className="col-sm-12">

          <div className="col-md-6">
            <UploadPhoto
              title={"球隊標誌"}
              Photo={logo_team}
              PhotoAuth={logo_team_auth}
              PhotoDate={logo_team_date}
              setIsLoading={setIsLoading}
              set_Photo={set_logo_team}
              set_PhotoAuth={set_logo_team_auth}
              set_PhotoDate={set_logo_team_date}
              isEdit={isEdit}
            />
          </div>



        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="row">
        {
          isAdd || isEdit ?
            <div className="col-sm-3 col-sm-offset-9">
              <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toAdd} isRight={true} />
            </div>
            :
            <EditButton action={toEdit} isRight={true} />
        }
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={false} />
      <SystemPromptInput />
    </>
  )
}